import { createSelector } from "reselect";

import { getCurrentIndividual } from "./individualSelectors";
import { getCurrentOrganization } from "./organizationSelectors";

export const getEmployerCanShowLedgerDispute = createSelector(
  [getCurrentIndividual, getCurrentOrganization],
  (individual, organization) =>
    Boolean(individual?.beta) || Boolean(organization?.betaOrganization)
);

export const getContractEmployerInBetaPool = (contract) =>
  Boolean(contract?.attributes?.employerInBetaPool);
